import { DocumentRepository } from "../domain/DocumentRepository";

export async function saveExpectedPayDate(repository: DocumentRepository,
  companyId: string,
  documentId:string, 
    documentExpectedPayDate:string, 
    documentType:string, 
    documentOrigin:string
): Promise<void> {
try{
await repository.saveExpectedPayDate(companyId, documentId, documentExpectedPayDate, documentType, documentOrigin);  
    }catch(error){
      console.log("error saveExpectedPayDate:" + error);
        throw new Error("Error saving expected pay date");
    }
  
}